import { FC, SVGProps } from 'react';

export const PurchaseIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 3.25C18.6234 3.25 20.75 5.37665 20.75 8V9H24L24.2041 9.01074C25.2128 9.11301 26 9.96435 26 11V24L25.9951 24.2061C25.8913 26.2512 24.2512 27.8913 22.2061 27.9951L22 28H10L9.79395 27.9951C7.7488 27.8913 6.10865 26.2512 6.00488 24.2061L6 24V11C6 9.96435 6.78722 9.113 7.7959 9.01074L8 9H11.25V8C11.25 5.37665 13.3766 3.25 16 3.25ZM8 10.5C7.72386 10.5 7.5 10.7239 7.5 11V24C7.5 25.3807 8.61929 26.5 10 26.5H22C23.3807 26.5 24.5 25.3807 24.5 24V11C24.5 10.7239 24.2761 10.5 24 10.5H20.75V13C20.75 13.4142 20.4142 13.75 20 13.75C19.5858 13.75 19.25 13.4142 19.25 13V10.5H12.75V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V10.5H8ZM16 4.75C14.2051 4.75 12.75 6.20508 12.75 8V9H19.25V8C19.25 6.20507 17.7949 4.75 16 4.75Z"
			fill="currentColor"
		/>
	</svg>
);
